<script>
import _chunk from 'lodash/chunk'
import Layout from '@layouts/main'
import ModalImage from '@components/ModalImage';

import { setComputed } from '@state/helpers'
import formatDate, { dateDiffInMinutes } from '@utils/format-date'

export default {
  page() {
    return {
      title: this.order.merchant.name,
    }
  },
  components: { Layout, ModalImage },
  filters: {
    formatDate,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    tickets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isModalImageActive: false,
      modalImageImage: '',
    }
  },
  computed: {
    ...setComputed,
    orderTimeInterval() {
      const dateDiff = dateDiffInMinutes(this.order.startDate, this.order.endDate);

      if(dateDiff > 60 * 24 * 30) {
        return this.$tc('global.ABOUT_TIME_MOUTH', dateDiff / (60 * 24 * 30), { minute: Math.floor(dateDiff / (60 * 24 * 30)) }/* (預計{minute}個月) */)
      }else if(dateDiff > 60 * 24) {
        return this.$tc('global.ABOUT_TIME_DAY', dateDiff / (60 * 24), { minute: Math.floor(dateDiff / (60 * 24)) }/* (預計{minute}天) */)
      }else if(dateDiff > 60) {
        return this.$tc('global.ABOUT_TIME_HOUR', dateDiff / 60, { minute: Math.floor(dateDiff / 60) }/* (預計{minute}小時) */)
      }else {
        return this.$tc('global.ABOUT_TIME_MINUTE', dateDiff, { minute: Math.floor(dateDiff) }/* (預計{minute}分鐘) */)
      }
    },
    orderProductType() {
      return this.order.productType || 'activity'
    },
    isNullOrder() {
      return typeof this.order === 'object' && Object.keys(this.order).length === 0
    }
  },
  methods: {
    openModalImage(isUse, image) {
      if(!isUse) {
        this.isModalImageActive = true;
        this.modalImageImage = image;
      }
    },
    chunkTicketCodes(codeArray, size) {
      return _chunk(codeArray, size)
    },
    handleToOrder() {
      this.$router.push({
        name: 'order-detail',
        params: {
          orderKey: this.order.id,
        },
        query: {
          language: this.$route.query.language,
        },
      })
    },
    handleToProduct() {
      this.$router.push({
        name: 'booking-product',
        params: {
          merchantAlias: this.order.merchant.alias,
          productId: this.order.productAlias,
        },
        query: {
          language: this.$route.query.language,
        },
      })
    },
    handleContact() {
      const vnodes = []

      if (this.order.merchant.email) {
        vnodes.push(
          <a href={`mailto:${this.order.merchant.email}`}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="envelope"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
            >
              <path
                fill="currentColor"
                d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
              ></path>
            </svg>
            {this.order.merchant.email}
          </a>
        )
      }

      if (this.order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
          <a href={`tel:${this.order.merchant.phoneNumber}`}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fal"
              data-icon="mobile-android-alt"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
            >
              <path
                fill="currentColor"
                d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
              ></path>
            </svg>
            {this.order.merchant.phoneNumber}
          </a>
        )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(messageElement, this.$t('global.CONTACT_PREFIX', { name: this.order.merchant.name }/* 聯繫{name} */), {
        distinguishCancelAndClose: false,
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
        ),
        confirmButtonClass: 'button is-primary is-rounded',
      })
    },
    takeLast(text, num = 5) {
      return text.substring(text.length - num, text.length)
    },
  },
}
</script>

<template>
  <Layout>
    <template v-if="!isNullOrder">
      <div class="booking-container">
        <div class="booking-section--outside has-text-centered">
          <div class="is-size-5 has-text-grey-dark has-text-weight-medium">{{ order.productName }}</div>
          <div class="order-datetime">
            <div>{{ order.startDate | formatDate('dateWeekDay') }}</div>
            <div class="order-datetime__time is-marginless has-text-accent">
              {{ order.startDate | formatDate('time') }}
              <h5 class="is-size-6 has-text-grey">{{orderTimeInterval}}</h5>
            </div>
          </div>
        </div>
        <b-collapse
          v-for="ticket in tickets"
          :key="ticket.name"
          class="booking-section"
          :class="$style.ticket"
        >
          <div slot="trigger" slot-scope="props" class="card-header" role="button">
            <div :class="$style['ticketHeader__title']" class="card-header-title">
              <div :class="$style['ticketHeader__name']" class="has-text-primary">{{ ticket.name }}</div>
              <div class="has-text-weight-medium">{{ ticket.introtext }}</div>
              <span
                class="has-text-grey-light"
              >{{ $t('global.QRCODE_GROUP_PEOPLE', { num: ticket.qty, total: (ticket.qty * ticket.size) }/* {num}組，可供{total}人使用 */) }}</span>
            </div>
            <div :class="$style['ticketHeader__icon']" class="card-header-icon">
              <span v-text="props.open ? $t('global.HIDE'/* 收合 */) : $t('global.OPEN'/* 展開 */)"></span>
              <span class="icon">
              <BaseIcon :name="props.open ? 'angle-down' : 'angle-up'" />
            </span>
            </div>
          </div>
          <div
            v-for="(codeGroup, groupIndex) in chunkTicketCodes(ticket.codes, ticket.size)"
            :key="groupIndex"
            :class="$style['qrcodeGroup']"
          >
            <div :class="$style['qrcodeGroup__header']">
              {{ $tc('global.QRCODE_GROUP', ticket.qty, { num: ( groupIndex + 1 ), size: ticket.qty }/* 第{num}組，共{size}組
              */) }}
            </div>
            <div :class="$style['qrcodeGroup__item']">
              <div
                v-for="code in codeGroup"
                :key="code.id"
                :class="[$style['qrcodeItem'],ticket.size === 1 ?
            $style['singleQrcode'] : '']"
              >
                <div :class="$style['qrcodeImg']">
                  <img
                    alt
                    :class="code.used ? $style['isUseQrcode'] : ''"
                    :src="`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${code.id}`"
                    @click="openModalImage(code.used, `https://api.qrserver.com/v1/create-qr-code/?size=460x460&data=${code.id}`)"
                  />
                  <div v-if="code.used" :class="$style['iconCheck']">
                    <BaseIcon name="check" />
                  </div>
                </div>
                <div
                  :class="$style['qrcode-text']"
                  class="has-text-weight-medium"
                >{{ $t('global.LAST_FIVE_DIGITS'/* 憑證編號末五碼 */) }}：{{takeLast(code.id)}}</div>
              </div>
            </div>
          </div>
        </b-collapse>
        <div class="booking-section">
          <div class="level subsection is-small">
            <h4
              class="level-left booking-section__title"
            >{{ $t('global.ADMISSION_USAGE_INSTRUCTION_TITLE'/* 入場憑證使用說明 */) }}</h4>
          </div>
          <div v-if="currentLanguage === 'zh-Hant'" class="subsection">
            <div class="subsection__title">如何進場？</div>
            <ol class="is-text-content">
              <li>請於現場出示下方QR Code憑證入場，無論使用手機、平板或列印，皆可順利報到。</li>
            </ol>
            <div class="subsection__title">電子憑證使用須知</div>
            <ol class="is-text-content">
              <li>以下QR Code即為您參加活動的電子票券，每張票券僅限該場活動使用，恕無法持其他任何憑證要求入場。</li>
              <li>商家之於票券有效狀態有最終解釋權。</li>
              <li>
                DingSomething僅為代售單位，活動內容、時間、注意事項等相關問題請
                <span
                  class="is-link-primary"
                  @click="handleContact"
                >聯繫商家</span> 。
              </li>
              <li>
                如您符合退票條件且需退票，請
                <span class="is-link-primary" @click="handleContact">聯繫商家</span> 。
              </li>
            </ol>
          </div>
          <div v-else class="subsection">
            <div class="subsection__title">how to admit?</div>
            <ol class="is-text-content">
              <li>please display the QRcode below to the staff. smartphone, tablet, laptop or printed are all acceptable.</li>
            </ol>
            <div class="subsection__title">QRcode admission notice</div>
            <ol class="is-text-content">
              <li>the QRcode is your official and only admission for the specific reservation. no other admission type accepted.</li>
              <li>DingSomething & the merchant keep the right to accept admissions.</li>
              <li>
                DingSomething provides the reservation service only. Please
                <span
                  class="is-link-primary"
                  @click="handleContact"
                >
                contact the
                merchant
              </span> for further details.
              </li>
            </ol>
          </div>
        </div>
        <div class="booking-section--outside">
          <div class="buttons">
            <b-button
              type="is-black"
              outlined
              rounded
              class="is-fullwidth"
              @click="handleToOrder"
            >{{ $t('global.BACK_TO_RESERVATION_DETAILS'/* 回預訂結果頁 */) }}</b-button>
            <b-button
              type="is-black"
              outlined
              rounded
              class="is-fullwidth"
              @click="handleToProduct"
            >{{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}</b-button>
          </div>
        </div>
      </div>
      <b-modal
        :active.sync="isModalImageActive"
        :width="500"
        :can-cancel="['escape','outside']">
        <ModalImage :image="modalImageImage" @close="isModalImageActive = false" />
      </b-modal>
    </template>
    <template v-else>
      <div class="booking-container">
        <div class="defaultBox">
          <img alt="merchant default" class="defaultBox__image" src="@assets/images/information_default.png" />
          <h1 class="defaultBox__text">
            {{$t('global.NOT_FOUND_PREFIX', { text: $t('global.ORDER') } /*找不到訂單*/)}}
          </h1>
        </div>
      </div>
    </template>
  </Layout>
</template>

<style lang="scss" module>
.ticketHeader {
  &__title {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    padding: 1.5rem;
    font-weight: normal;
  }
  &__name {
    @extend %typography-medium;

    margin-bottom: 1rem;
    font-weight: $heading-font-weight;
  }
  &__icon {
    padding: 2rem;
    &:hover {
      color: $color-primary;
    }
    .icon {
      margin-left: 1rem;
    }
  }
}
.qrcodeGroup {
  padding: 1.5rem 0;
  &:not(:last-child) {
    border-bottom: 1px dashed $color-border-base;
  }
  &__header {
    margin-bottom: 1.5rem;
    color: $grey;
  }
  &__item {
    display: flex;
    flex-wrap: wrap;
    .qrcodeItem {
      flex: 0 0 50%;
      flex-wrap: wrap;
      margin-bottom: 2rem;
      text-align: center;
      .qrcodeImg {
        position: relative;
        max-width: 35vw;
        width: 220px;
        margin: 0 auto 0.5rem;
        img:not(.isUseQrcode) {
          &:hover {
            transition: box-shadow 0.3s;
            cursor: pointer;
            box-shadow: 0 0 25px 0 rgba(178, 180, 181, 0.35);
          }
        }
      }
      .isUseQrcode {
        opacity: 0.65;
      }
      .iconCheck {
        position: absolute;
        top: 50%;
        left: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 70px;
        height: 70px;
        margin-top: -35px;
        margin-left: -35px;
        font-size: 45px;
        color: #ccff8f;
        background: #4caf4f;
        border-radius: 100%;
      }
    }
    .singleQrcode {
      flex: 0 0 100%;
    }
  }
}
</style>
